/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteSignatoryCommand
 */
export interface DeleteSignatoryCommand {
    /**
     * 
     * @type {number}
     * @memberof DeleteSignatoryCommand
     */
    proposalId: number;
    /**
     * 
     * @type {number}
     * @memberof DeleteSignatoryCommand
     */
    signatoryId: number;
}

/**
 * Check if a given object implements the DeleteSignatoryCommand interface.
 */
export function instanceOfDeleteSignatoryCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "proposalId" in value;
    isInstance = isInstance && "signatoryId" in value;

    return isInstance;
}

export function DeleteSignatoryCommandFromJSON(json: any): DeleteSignatoryCommand {
    return DeleteSignatoryCommandFromJSONTyped(json, false);
}

export function DeleteSignatoryCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteSignatoryCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'proposalId': json['ProposalId'],
        'signatoryId': json['SignatoryId'],
    };
}

export function DeleteSignatoryCommandToJSON(value?: DeleteSignatoryCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProposalId': value.proposalId,
        'SignatoryId': value.signatoryId,
    };
}

